/**
 * Given a list of selected lists, determines if the phone field
 * should be required.
 * @param {array} selectedLists - An array of user-selected lists, with types.
 * @returns {boolean} - True if the phone field is required, false otherwise.
 */
const phoneRequired = (selectedLists) => undefined !==
  selectedLists.find((list) => list.includes('-sms'));

export default phoneRequired;
